import { Box, Flex, Image, useBreakpointValue } from "@chakra-ui/react"
import { BlockImageGridEntityHydrated } from "@jackfruit/common"
import React from "react"
import Wrapper from "../Wrapper"
import { Link as GatsbyLink } from "gatsby"

interface Props {
  config: BlockImageGridEntityHydrated
}

const ImageGridBlock: React.FC<Props> = ({ config }) => {
  const {
    alignment,
    alignmentXs,
    alignmentMd,
    columnWidth,
    columnWidthXs,
    columnWidthMd,
    columnUnit,
    columnUnitXs,
    columnUnitMd,
    assetsDesktop,
    assetsMobile,
    assetsTablet,
  } = config

  const assets = useBreakpointValue({
    base: assetsMobile,
    md: assetsTablet,
    lg: assetsDesktop,
  })

  const columnWidthValue = useBreakpointValue({
    base: `${columnWidthXs}${columnUnitXs}`,
    md: `${columnWidthMd}${columnUnitMd}`,
    lg: `${columnWidth}${columnUnit}`,
  })

  const getAlignment = (alignment: number) => {
    let alignItems = "center"
    switch (alignment) {
      case 1:
        alignItems = "flex-start"
        break
      case 2:
        alignItems = "flex-end"
        break
    }
    return alignItems
  }
  return (
    <Wrapper
      py={20}
      flexDir={"row"}
      hasSeparator={true}
      alignItems="center"
      flexWrap="wrap"
    >
      <Flex
        wrap="wrap"
        mx="auto"
        justifyContent={[
          getAlignment(alignmentXs),
          getAlignment(alignmentMd),
          getAlignment(alignment),
        ]}
      >
        {assets &&
          assets.map(item => (
            <Box key={item.id} w={columnWidthValue} padding={2}>
              {item.link ? (
                <GatsbyLink to={item.link ?? "/"}>
                  <Image src={item.path} alt={item.alt} width="100%" />
                </GatsbyLink>
              ) : (
                <Image src={item.path} alt={item.alt} width="100%" />
              )}
            </Box>
          ))}
      </Flex>
    </Wrapper>
  )
}

export default ImageGridBlock
